import type { SdAppRole } from "@sd/lib/sdPaths";

export const SD_EXTERNAL_AGENT_ROLE = "ServiceDesk_External_Agent" as const;
export const SD_EXTERNAL_CUSTOMER_ROLE = "ServiceDesk_External_Customer" as const;

/** Agent workbench shell — same layout as ServiceDesk_Agent (not Super Agent / Admin). */
export const SD_AGENT_SHELL_ROLES = [
  "ServiceDesk_Agent",
  SD_EXTERNAL_AGENT_ROLE,
  SD_EXTERNAL_CUSTOMER_ROLE,
] as const;

export type SdAgentShellRole = (typeof SD_AGENT_SHELL_ROLES)[number];

const SD_ROLE_PRIORITY: SdAppRole[] = [
  "ServiceDesk_Admin",
  "ServiceDesk_SuperAgent",
  "ServiceDesk_Agent",
  SD_EXTERNAL_AGENT_ROLE,
  SD_EXTERNAL_CUSTOMER_ROLE,
  "ServiceDesk_User",
];

export function isSdAppRole(value: string): value is SdAppRole {
  return (SD_ROLE_PRIORITY as string[]).includes(value);
}

/** Restricted agent UI (no Super Agent extra queues / Close-column privileges). */
export function isAgentShellRole(
  role: string | null | undefined
): role is SdAgentShellRole {
  return (
    role === "ServiceDesk_Agent" ||
    role === SD_EXTERNAL_AGENT_ROLE ||
    role === SD_EXTERNAL_CUSTOMER_ROLE
  );
}

/** Super Agent only — never infer from “not Agent”. */
export function isSuperAgentRole(role: string | null | undefined): boolean {
  return role === "ServiceDesk_SuperAgent";
}

export function isSupportAgentRole(role: string | null | undefined): boolean {
  return isAgentShellRole(role) || isSuperAgentRole(role);
}

export function isExternalSdRole(role: string | null | undefined): boolean {
  return role === SD_EXTERNAL_AGENT_ROLE || role === SD_EXTERNAL_CUSTOMER_ROLE;
}

export function pickServiceDeskRole(
  roles: { role_name?: string }[]
): SdAppRole | null {
  const names = roles.map(r => r.role_name);
  return SD_ROLE_PRIORITY.find(name => names.includes(name)) ?? null;
}
